.inspiration-tile {
  display: block;
  text-decoration: none;
  text-align: center;
  position: relative;

  ::slotted(lilu-img) {
    width: auto;
    max-width: 100%;
    margin-bottom: 20px;
  }

  ::slotted(a) {
    display: block;
    margin-bottom: 40px;
  }

  ::slotted(lilu-link) {
    margin-top: 20px;
  }

  ::slotted(.inspiration-tile-input) {
    display: none;
  }

  ::slotted(.label) {
    display: block;
    font-family: var(--primary-font);
    width: calc(100% + 2px);
    left: -1px;
    position: absolute;
    max-height: 39.25px;
    overflow: hidden;
    transition: 0.5s ease-out;
    bottom: 39.25px;
    background-color: var(--color-white);
    padding-top: 12px;
    padding-left: 32px;
    padding-right: 32px;
    cursor: pointer;
  }
}
